import { render, staticRenderFns } from "./MerchantUnavailableOrders.vue?vue&type=template&id=cfc6588e"
import script from "./MerchantUnavailableOrders.vue?vue&type=script&lang=js"
export * from "./MerchantUnavailableOrders.vue?vue&type=script&lang=js"
import style0 from "./MerchantUnavailableOrders.vue?vue&type=style&index=0&id=cfc6588e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports